// One place decides whether we're offline, so the banner and the pages agree. The browser's
// navigator.onLine misses captive wifi and dead mobile data, so a failed request counts too.
const EVENT = "lp-offline-change";

let offline = typeof navigator !== "undefined" ? navigator.onLine === false : false;

const emit = () => window.dispatchEvent(new CustomEvent(EVENT, { detail: { offline } }));

export const getOfflineState = () => ({ offline });

export const markOffline = () => {
  if (offline) return;
  offline = true;
  emit();
};

export const markOnline = () => {
  // The browser is certain it has no connection — a lucky cached read doesn't change that.
  if (typeof navigator !== "undefined" && navigator.onLine === false) return;
  if (!offline) return;
  offline = false;
  emit();
};

export const subscribeOffline = (fn) => {
  const handler = (e) => fn(e.detail || getOfflineState());
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};

export const watchConnection = () => {
  window.addEventListener("offline", markOffline);
  window.addEventListener("online", markOnline);
};
